import { render, staticRenderFns } from "./TableTotal.vue?vue&type=template&id=60775cf6&scoped=true"
import script from "./TableTotal.vue?vue&type=script&lang=js"
export * from "./TableTotal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60775cf6",
  null
  
)

export default component.exports